import { apiSlice } from "./apiSlice";
import { QUESTIONS_URL } from "../constants";

export const questionApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // Create question
    createQuestion: builder.mutation({
      query: (data) => ({
        url: QUESTIONS_URL,

        method: "POST",

        body: data,
      }),

      invalidatesTags: ["Question"],
    }),

    // Get questions by quiz
    getQuestionsByQuiz: builder.query({
      query: (quizId) => ({
        url: `${QUESTIONS_URL}/quiz/${quizId}`,
      }),

      providesTags: ["Question"],

      keepUnusedDataFor: 5,
    }),

    // Get questions by chapter
getQuestionsByChapter: builder.query({
  query: (chapterId) => ({
    url: `${QUESTIONS_URL}/chapter/${chapterId}`,
  }),

  providesTags: ["Question"],

  keepUnusedDataFor: 5,
}),

    // Get question details
    getQuestionDetails: builder.query({
      query: (id) => ({
        url: `${QUESTIONS_URL}/${id}`,
      }),

      providesTags: ["Question"],

      keepUnusedDataFor: 5,
    }),
    

    // Update question
    updateQuestion: builder.mutation({
      query: (data) => ({
        url: `${QUESTIONS_URL}/${data.questionId}`,

        method: "PUT",

        body: data,
      }),

      invalidatesTags: ["Question"],
    }),

    getQuestionAvailabilityByChapter: builder.query({
  query: ({
    chapter,
    difficulty,
  }) => ({
    url: `${QUESTIONS_URL}/availability`,
    params: {
      chapter,
      difficulty,
    },
  }),
}),

    // Delete question
    deleteQuestion: builder.mutation({
      query: (id) => ({
        url: `${QUESTIONS_URL}/${id}`,

        method: "DELETE",
      }),

      invalidatesTags: ["Question"],
    }),

  }),
});

export const {
  useCreateQuestionMutation,

  useGetQuestionsByQuizQuery,

  useGetQuestionsByChapterQuery,

  useGetQuestionDetailsQuery,

  useUpdateQuestionMutation,

   useGetQuestionAvailabilityByChapterQuery,

  useDeleteQuestionMutation,
} = questionApiSlice;
